import { useRequest } from 'utils/useFetch';

import request from '../../../utils/useAxios';
import {
  UUCAFE_WORLD_DETAIL_ADD_FAIL,
  UUCAFE_WORLD_DETAIL_ADD_REQUEST,
  UUCAFE_WORLD_DETAIL_ADD_SUCCESS,
  UUCAFE_WORLD_DETAIL_FAIL,
  UUCAFE_WORLD_DETAIL_REQUEST,
  UUCAFE_WORLD_DETAIL_SUCCESS,
  UUCAFE_WORLD_DETAIL_UPDATE_FAIL,
  UUCAFE_WORLD_DETAIL_UPDATE_REQUEST,
  UUCAFE_WORLD_DETAIL_UPDATE_SUCCESS,
  UUCAFE_WORLD_LIST_FAIL,
  UUCAFE_WORLD_LIST_REQUEST,
  UUCAFE_WORLD_LIST_SUCCESS,
} from '../../constants/data/uuCafeWorldConstants';

/*
* @Params
* {
  "page": 0,
  "page_size": 0,
  "type": 0,
  "order": "string",
  "order_by": "string",
  "keyword": "string"
  }
*
*/
export const getCafeWorldList = data => {
  return async (dispatch, getState) => {
    await useRequest({
      data,
      dispatch,
      failConstant: UUCAFE_WORLD_LIST_FAIL,
      method: 'post',
      requestConstant: UUCAFE_WORLD_LIST_REQUEST,
      successConstant: UUCAFE_WORLD_LIST_SUCCESS,
      url: '/Backend/Cafe_Info/cafeworld/list',
    });
  };
};

export const getCafeWorldDetail = params => {
  return async (dispatch, getState) => {
    await useRequest({
      dispatch,
      failConstant: UUCAFE_WORLD_DETAIL_FAIL,
      method: 'get',
      requestConstant: UUCAFE_WORLD_DETAIL_REQUEST,
      successConstant: UUCAFE_WORLD_DETAIL_SUCCESS,
      url: `/Backend/Cafe_Info/cafeworld/${params.id}`,
    });
  };
};

/*
* @Params
id integer($int32)
title string
title_en string
content string
content_en string
startTime string($date-time)
endTime string($date-time)
img_files array
*/
export const addCafeWorldDetail = data => {
  return async (dispatch, getState) => {
    await useRequest({
      data,
      dispatch,
      failConstant: UUCAFE_WORLD_DETAIL_ADD_FAIL,
      method: 'post',
      requestConstant: UUCAFE_WORLD_DETAIL_ADD_REQUEST,
      successConstant: UUCAFE_WORLD_DETAIL_ADD_SUCCESS,
      url: '/Backend/Cafe_Info/cafeworld/add',
    });
  };
};

export const updateCafeWorldDetail = data => {
  return async (dispatch, getState) => {
    await useRequest({
      data,
      dispatch,
      failConstant: UUCAFE_WORLD_DETAIL_UPDATE_FAIL,
      method: 'post',
      requestConstant: UUCAFE_WORLD_DETAIL_UPDATE_REQUEST,
      successConstant: UUCAFE_WORLD_DETAIL_UPDATE_SUCCESS,
      url: '/Backend/Cafe_Info/cafeworld/update',
    });
  };
};

/*
  @params
  data:
  id: integer($int32)
*/
export const deleteCafeWorldDetail = async params => {
  return await request({
    method: 'get',
    params,
    url: '/Backend/Cafe_Info/cafeworld/delete',
  });
};
